<template>

    <footer class="mm-section mm-section__footer"
        :style="{
                backgroundImage: `url(${publicPath}css/images/homepage/Footer_image.jpg)`
        }">
        <div class="mm-section__footer-wrapper">
            <div class="mm-section__mask"></div>
            <div class="mm-section-content box--flex-vertical">
                <div class="mm-section__row mm-section__row--space-bottom-l">
                    <span class="headline headline--second headline--colored headline--no-space">
                        {{$t('UI.footer.contactHeading')}}
                    </span>
                </div>
                <div class="mm-section__row mm-section__row--space-bottom-l">
                    <div class="mm-section__footer-item">
                        <div class="mm-section__footer-line mm-section__footer-line--bold">
                            {{$t('UI.footer.contactData.name')}}
                        </div>
                        <div class="mm-section__footer-line">
                            {{$t('UI.footer.contactData.address1')}}
                        </div>
                        <div class="mm-section__footer-line">
                            {{$t('UI.footer.contactData.address2')}}
                        </div>
                    </div>
                    <div class="mm-section__footer-item">
                        <div class="mm-section__footer-line">
                            <span class="mm-section__footer-label">
                                {{$t('UI.footer.email')}}
                            </span>
                            {{$t('UI.footer.contactData.email')}}
                        </div>
                        <div class="mm-section__footer-line mm-section__footer-line--space-bottom">
                            <span class="mm-section__footer-label">
                                {{$t('UI.footer.phone')}}
                            </span>
                            {{$t('UI.footer.contactData.phone')}}
                        </div>
                        <div class="mm-section__footer-line">
                            <span class="mm-section__footer-label">
                                {{$t('UI.footer.gps')}}
                            </span>
                            {{$t('UI.footer.contactData.gps')}}
                        </div>
                    </div>
                    <div class="mm-section__footer-item">
                        <div class="mm-section__footer-line">
                            <span class="mm-section__footer-label">
                                {{$t('UI.footer.ico')}}
                            </span>

                            {{$t('UI.footer.contactData.ico')}}
                        </div>
                        <div class="mm-section__footer-line mm-section__footer-line--space-bottom">
                            <span class="mm-section__footer-label">
                                {{$t('UI.footer.ico_dph')}}
                            </span>
                            {{$t('UI.footer.contactData.ico_dph')}}
                        </div>
                        <div class="mm-section__footer-line mm-section__footer-line--small">
                            {{$t('UI.footer.contactData.smallInfo')}}
                        </div>
                    </div>
                    <div class="mm-section__footer-item"></div>
                </div>

                <div v-if="feeadbackForm"
                    class="mm-section__row mm-section__row--space-bottom-l mm-section__row--vertical">
                    <span class="headline headline--fourth headline--colored">
                        {{$t('UI.footer.feedback.heading')}}
                    </span>
                    <p class="mm-section__footer-feedback-info">
                        {{$t('UI.footer.feedback.description')}}
                    </p>

                    <form @submit.prevent="onSubmit">
                        <Field
                            className="input-field--dark input-field--short"
                            :trimModel="true"
                            :fieldModel="$v.email"
                            :field="usernameField">
                        </Field>

                        <TextAreaField
                            :sizeXL="true"
                            className="materialize-textarea--xl input-field input-field--dark input-field--medium"
                            :fieldModel="$v.comment"
                            :field="commentField">
                        </TextAreaField>
                        <p v-if="submitStatus === 'ERROR'"
                            class="text text--error">
                            {{$t('UI.footer.feedback.error')}}
                        </p>
                         <button
                            v-if="submitStatus === 'REQUEST'"
                            type="submit"
                            disabled
                            class="button button--small-text button--wider-border default--button button--l button--uppercase button--float-left">
                            {{$t('UI.footer.feedback.sending')}}
                        </button>
                        <button
                            v-else
                            type="submit"
                            class="button button--small-text button--wider-border default--button button--l button--uppercase button--float-left">
                            {{$t('UI.footer.feedback.send')}}
                        </button>
                    </form>
                </div>

                <div v-if="submitStatus === 'SUCCESS'"
                    class="mm-section__row mm-section__row--space-bottom-l mm-section__row--vertical">
                    <span class="headline headline--fourth headline--colored">
                        {{$t('UI.footer.feedback.success')}}
                    </span>
                </div>

                <div class="mm-section__row">
                    <div class="mm-section__footer-toolbar">
                        <a  v-for="item in (this.$te('UI.footer.socialIcons') ? this.$t('UI.footer.socialIcons') : [])"
                            :key="item.id"
                            :href="item.url"
                            class="mm-section__footer-toolbar-item">
                            <i :class="item.icon"></i>
                        </a>
                        <div class="mm-section__footer-toolbar-pipe"></div>
                        <router-link
                            :to="localeRoute('help')"
                            class="mm-section__footer-toolbar-item">
                            FAQ
                        </router-link>
                        <a  @click="openFeedback"
                            href="#"
                            :title="$t('UI.footer.contactLinkTitle')"
                            class="mm-section__footer-toolbar-item">
                            <i class="icon icon-contact "></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </footer>
</template>

<script>
import Field from '@/components/ui/Field';
import TextAreaField from '@/components/ui/TextAreaField';
import { required, email } from 'vuelidate/lib/validators'
import { sendFeedBack } from '../../services/MapsfyApi';

export default {
    components: {
        Field,
        TextAreaField
    },
    data() {
        return {
            email: "",
            comment: "",
            feeadbackForm: false,
            submitStatus: null,
            usernameField: {
                atrName: "email",
                dataType: "text",
                descr: this.$t('components.auth.login.email_field_desc'),
                isMandatory: true,
                maxValue: "85",
                minValue: "5",
                title: this.$t('UI.footer.feedback.email')
            },
            commentField: {
                atrName: "comment",
                dataType: "text",
                descr: this.$t("components.order.dispute.disputeForm.text_title"),
                isMandatory: true,
                title: this.$t('UI.footer.feedback.message')
            },
            publicPath: process.env.BASE_URL,
        };
    },
    validations: {
        email: {
            required,
            email
        },
        comment: {
            required
        }
    },
    methods: {
        openFeedback(e) {
            e.preventDefault();
            this.feeadbackForm = true;
            this.submitStatus = null;
        },
        onSubmit() {
            this.$v.$touch();
            this.submitStatus = null;
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR';
            }

            if (!this.$v.$invalid) {
                this.submitStatus = "REQUEST";
                sendFeedBack({email: this.email, message: this.comment})
                    .done(res => {
                        console.log('RES: ', res);
                        this.submitStatus = "SUCCESS";
                        this.feeadbackForm = false;
                    })
                    .fail(() => {
                        this.submitStatus = "failure";
                    });
            }
        }
    }

}
</script>